import React, { Component } from 'react';
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import chart from './d3/d3-sensitivitychart';

class SensitivityChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.chart = chart()
      .width(this.props.width)
      .height(this.props.height)
      .on('selected', this.props.onSelected)
      .selected(this.props.selected)
      .threshold(this.props.threshold)
      .triggersEnabled(this.props.triggersEnabled)
      .units(this.props.units)
      .legendLabels(this.props.legend)
      .xAxisFormatter(this.props.xAxisFormatter)
      .yAxisFormatter(this.props.yAxisFormatter)
      .xLabel(this.props.xLabel)
      .yLabel(this.props.yLabel)
      .tolerance(this.props.tolerance);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart);
  }

  componentDidUpdate() {
    this.chart
      .width(this.props.width)
      .height(this.props.height)
      .selected(this.props.selected)
      .threshold(this.props.threshold)
      .triggersEnabled(this.props.triggersEnabled)
      .yAxisFormatter(this.props.yAxisFormatter)
      .yLabel(this.props.yLabel)
      .units(this.props.units)
      .legendLabels(this.props.legend)
      .tolerance(this.props.tolerance);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart);
  }

  componentWillUnmount() {
    this.chart
      .cleanup();
  }

  render() {
    return <div ref="chart" style={{ width: '100%' }} />
  }
}

export default withTitle(SensitivityChart);



// WEBPACK FOOTER //
// ./src/charts/SensitivityChart.js